/*eslint no-unused-vars:0 no-trailing-spaces:0 */
var _ = require("ES/lib/lodash");
var dd = require("ES/lib/dd");
var esUtils = require("ES/utils/esUtils");

module.exports = {
	component: dd.createClass({
		getInitialState: function() {
			return {generated_options_list: null, show_text_field: false};
		},
		__onMultiChange: function(e){
			var options = e.target.options;
			var new_value = [];
			for ( var i = 0, l = options.length; i < l; i = i + 1 ) {
				if ( options[i].selected ) {
					new_value.push(options[i].value);
				}
			}
			this.props.onChange(new_value);
		},
		__onTextChange: function(e) {
			this.props.onChange(e.target.value);
		},
		__showTextField: esUtils.wrapPreventDefault(function(){
			this.setState({show_text_field: true});
		}),
		__hideTextField: esUtils.wrapPreventDefault(function(){
			this.setState({show_text_field: false});
		}),
		render: function(){

			var field = this.props.field;
		    var selected = _.isArray(this.props.value) ? this.props.value : (this.props.value !== undefined && this.props.value !== '' ? [this.props.value] : []);
			var options = _.pairs(field.options);

			var sorted_options = [];
			if ( this.state.generated_options_list !== null ) {
				sorted_options = this.state.generated_options_list;
			} else {
				_.each(selected, function(option_value) {
					sorted_options.push(option_value);
				});
				_.each(options, function(option) {
					if ( _.indexOf(sorted_options, option[0]) < 0 ) {
						sorted_options.push(option[0]);
					}
				});
				this.setState({generated_options_list: sorted_options});
			}

			return dd.div(null,
				(this.state.show_text_field ? dd.div(null,
					dd.input({type: 'text', name: field.name, className: 'form-control', onChange: this.__onTextChange}),
					dd.a({href: '#', className: 'group-codes-cancel', onClick: this.__hideTextField}, 'Cancel')
				) : dd.div(null, 
					dd.span({className: 'text-muted group-codes-ctrl-text'}, 'Ctrl for multiple'),
					dd.a({href: '#', className: 'group-codes-add-new', onClick: this.__showTextField}, '+ Create Code'),
					dd.select({
							name: field.name,
							value: selected,
							onChange: this.__onMultiChange,
							className: 'form-control group-codes-select',
							multiple: true
						},
						_.map(sorted_options, function(option_value) {
							return dd.option({value: option_value, key: option_value}, option_value);
						})
					)
				))
			);
		}
	})
};


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/GroupCodeSelect.js